'use client'

import React from 'react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { ArrowLeft, BookOpen } from 'phosphor-react'
import { Link } from '@/lib'
import { useParams } from 'react-router'
import Components from '../components'

// Story content - update this with your actual stories from the Google Doc
// Use the story ID from the URL to find the matching story
const storyContent: Record<string, {
  id: string
  title: string
  date?: string
  content: string | React.ReactNode
}> = {
  'stuffy-kitchen': {
    id: 'stuffy-kitchen',
    title: 'Stuffy Kitchen',
    content: (
      <>
        <p className="text-slate-800 leading-relaxed mb-4">
          It's already late and the scrubber is old as fuck and I'm sick of the tin clinks.  These pots are not even stainless steel.  I'm a goddamn dishwasher, that's all I am.  That's my lot in life.  This is where I end up.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Twilight put down the sponge.  Put down the soap.  The sharp yet sweet aroma of lemon-lime glided into both nostrils with every deep breath in.  Then a BITCHSLAP in the face of that garbage grease.  It's gotta break down in the Dawn.  She mused.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          The soaky steel, not stainless, bobbing up and down in the water, slow-like, buoy-like, just releasing the stench of dirty dishwater.  Grease always smells like trash bags. Twilight thought, while pulling off the rubber gloves.  This isn't Cinderella.  These dishes couldn't possibly get washed before the end of the night.  Locked in with the clock ticking.  In this game, the kitchen represented hell.  Twilight thought about this, too, and all the wonderful things outside this kitchen.  Birds. Trees. Birds sitting IN trees!  Trees with birds resting on their arms. And ice cream.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "You just gonna keep shakin' your head and muttering to yourself, Twie?" Hank spurted out.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "What, you need another break?"  Hank didn't have much patience for self-loathing. And certainly didn't have much time for any noise that wasn't his own voice.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Easy for you to say, this stuff comes easy.  You got like 8 arms," Twilight spouted back.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "I don't have eight arms, don't be insulting. Just get back to it.  We're never gonna get this done in time for the party if you don't just hustle a bit."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "We're NEVER gonna get this done.  Forget the party." Twilight relented.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Why don't you give me those and come over here and chop some vegetables?" Hank put down the knife and walked over to the sink.  He pointed at the half-sliced vegetables with two arms and gave a stern look to Twilight.  "You always do this, Twie, and then we're crazy late and the food is cold, and everyone is already done eating. Why can't you just focus on what we are doing, you're always so distracted.  And like EVERYTHING is bad to you.  You may look all sparkly and cute, but you're always just grey."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Twilight started to cry.  A tear-filled shout came blurting out.  "You're always squeezing me with your little tentacles!  Fine!  I'll chop the vegetables.  I can't even hold the goddamn knife right." Twilight started to frantically swing the knife at the vegetables. "Take that you fucking zucchini!"
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Hank flinched a bit, but then just turned around and continued pot-scrubbing, like everything was normal. Twie was right.  It WAS easy for him.  He got it done really fast.  And then he boiled the potatoes.  And then he sauteed the onions. And they didn't say much more to each other.  They just frantically did their jobs and grunted and grumbled and glared their way through the recipe.  Sure, there was the occasionally mumbled "hey yah so I'm just gonna…and u got the–" but that was about it.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          When the food was done, they had to rush.  In fact, when they looked up at the clock after angrily slapping together some sort of potato smish crumple, the airless silence balloon immediately filled with the chaotic breath of their hurriedness.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Get the serving spoons!  I'll get the napkins!"
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Should we bring a bottle of wine? Ohhh, YOU pick one. YOU'RE the wine person."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Then Hank grabbed the keys.  Twie grabbed the coats. Hank grabbed the food. Then they bolted out the kitchen door like a flash of lightning, the last sound heard in the kitchen was the rattling on the brass as he twisted the key to lock the door.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Hankie!  Twie Twie!  You gotta bring me, too!" Hannah gave a stern look, half-smirk to both of the plushies. Then she squeezed them against her chest, first kissing the octopus, and then the pony. "It's ok, I know you work a lot."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          The phone on the wall rang. They still had a house phone, for some reason, for just this sort of occasion.  Hannah didn't answer right away, because, well, mommy told her not to.  But after like 100 rings she finally reached for the receiver.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Hello?" She gently responded. "Yeah, I am.  In the kitchen. Yeah, the door's locked. Ok, mommy. Love you. bye."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Then Hannah waited there on the kitchen floor and continued to play quietly with Twilight and Hank, thinking about the day without even realizing it.  She waited until her parents came home.  She waited and wondered about what it was like to be a mommy, to be HER mommy, until finally her plush friends had no more energy left to re-enact the day. Then she laid them down to sleep, and she laid herself down to sleep, and she held them close like a child can.  And they held her back, like parents should.
        </p>
      </>
    )
  },
  'lady-of-the-flies': {
    id: 'lady-of-the-flies',
    title: 'Lady of the Flies',
    content: (
      <>
        <p className="text-slate-800 leading-relaxed mb-4">
          I couldn't stand the feeling of their little grimy limbs clinging to my skin. They hold on tightly until you move, ever so slightly. It could be a gentle shift in your seat or just a deep breath. Flies will immediately take off, but just as soon will begin to swarm around you.  It's calculated hysteria. They will come back, but not before frantically searching for another space, another way to grab ahold of you and make you squirm in your chair.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          She motioned with her arm to sit next to her. She was resting on the arm of a metal lawn chair. I wasn't feeling comfortable at the prospect of sitting, but then again I attributed that to my anxiety. I sat down to carefully into the seat where I was beckoned.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Is something bothering you?" she inquired, while rubbing her thumb back and forth across the skin of a pear she held firmly in her hand, preparing to take a bite into the smoothed out skin of the tender fruit.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "It's just these flies. They keep landing all over me…"
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "You don't like flies?" she raised her eyebrow.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Well, not really," I replied.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Just be zen about it. Imagine they are giving you little kisses all over your body. Making love to your skin." The mere suggestion made my skin crawl. The thought of insect lovemaking doesn't really turn me on. And this comment only further increased my suspicion about what these people were doing out here in the forest. It was supposed to be just a nice potluck, but I immediately felt like I would not be allowed to leave if I tried. I shifted in my chair, listening to them discuss "the system" as I carefully inspected my surroundings.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Dotted throughout the trees were a few old leaky caravans teeming with junk. Just random, worn down objects of no use. Ripped stuffed animal. Broken lawn chair. Scratched up frying pan. Crumpled checkered plastic tablecloth. And threading his way between the caravans, popping in and out of vision, was a skulking figure with long matted hair and a beard.  He was smoking, and would occasionally walk back into the circle of potluckers. After a while, he would wander back into the wooded caravan junkyard, each time with someone else from the circle who seemed to be convinced in joining him. But each time he came back to the clearing, he returned alone.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          As I listened to the discussions in the group, I tried my best not to be an active participant.  I don't like to talk about what I believe, and the discussion seemed to be slanting philosophical and political.  It also became clear to me with each passing minute that most of the people here were not new guests, but had been here before and perhaps even lived on the grounds.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Do you believe we are here for a reason?  That we have a higher purpose?" the lady of the flies prodded.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Sure? …I mean, I guess so. We probably have something we're supposed to be doing here on earth, if that's what you're asking," I muttered.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Do you believe you are living your purpose?" She continued.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "I don't know, really.  I suppose so, yes." I softly replied.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          She leered at me for some time before spurting. "I don't think you are living your truth.  You do have a greater purpose, you just don't know it yet. I can see it."  As she locked onto me as her target, I felt once again the calculated buzz before the next attempt to grab hold. The others were looking in my direction now, too. I saw the deadness in their eyes as I scanned their faces. Then I briefly caught the eye of my partner, who I had almost forgotten was with me.  His pupils were needle points, piercing back at me. I pursed my lips carefully, then contorted them toward the right side of my face. I had hoped he would be alert enough to remember this way of indicating we needed to leave quietly. He immediately caught on, and shortly thereafter asked where the restroom was located.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          The man next to him chuckled, "The world is our bathroom. Anywhere there's grass, man."  Of course hippies don't use restrooms. He disappeared into the trees in the direction I had pointed. Now it was my turn.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Well?" she insisted. "What do you think your purpose is? I can see your purpose, but do you know it yet?  I could tell right away in the way you responded to my facebook post. Do you want to know what I know? –actually, no. I want you to think about it first. Tell me what you know about your purpose."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          I lifted my finger to point ever so delicately toward the table of food. "I think I need to nibble on something while I noodle on that for a minute," a tiny smile cracking my mouth as I got up to move toward the table. I snatched up a carrot stick and took a nibble. "Actually, could I use your toilet?" then I laughed/sighed, "Sorry, I forgot we can just go anywhere outside. I'll just be right back."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Ne ne ne," she wagged her finger. "Not the ladies. We have our own restroom. Ladies can't go pee in the woods–it's a rule here. We've got to have rules and obey them. After all, we're not savages. I will take you." Her red flies eyes lit up as she sprung up to guide me. She took hold of my arm in a way that was more of a forceful yank than a gentle guiding hand.  I was hustled to an area behind the caravans, which was another clearing.  At the other side of the clearing was another caravan. This one a bit less dilapidated, but was still in a rusty steel sort of way.  There were antlers on a plaque hanging next to the aluminum screen door that read "Bartleby's."  She raised her arm up and pointed to the door, as if sentencing me to my death.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "The restroom is in there?" I quivered as I asked. I immediately felt the cold, white fear electrify my veins like the icy shock from a 9-volt battery touching your tongue.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "It's inside that door. Go on. I'll wait for you."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "I would prefer not to."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Don't you have to pee? You asked to go to the restroom. It's just right here." She picked at her teeth, starting to look impatient.  Nothing so aggravates an earnest person as a passive resistance.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          I looked again at the caravan.  I knew there was no beast, not with claws and all that, I mean—but I know there isn't no fear, either. "Sorry, I sometimes have a little anxiety around using the bathroom and all of a sudden I just don't have to go."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Come on, it'll be fine.  I'll be waiting right here," here voice softened.  I consigned myself to the idea that maybe I was just making some things up in my head. I reached for the handrail, pulled the door open, and poked my head inside. And in the middle… with filthy body, matted hair, and unwiped nose, there was my partner.
        </p>
      </>
    )
  },
  'pants-again': {
    id: 'pants-again',
    title: 'Pants again',
    content: (
      <>
        <p className="text-slate-800 leading-relaxed mb-4">
          A cold gust slapped on Jarrod's goose-pimpled skin.  It was so warm yesterday, but today you could feel the bite in the air.  Why did it have to happen today?  He looked out onto the street for someplace he could take refuge and make a plan.  He rushed out into the road and made a dash for the dry cleaners.  It was quite early, but a dry cleaner usually would be open at this time.  Careful not to be seen, he tucked behind a corner and peeked into the store to make sure nobody was inside.  Finally, a stroke of luck.  He slipped into the space quietly and rang the bell at the counter.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "How may I–Oh, no.  No, no, no, no, no.  You need to go or I am calling the police!" the clerk chirped.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Please, please…I just need some help.  If you have a spare set of clothes, I really am not picky.  Maybe something with stains.  All my things were taken."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Oh, you don't think I know where you came from," the little lady spat, "I know your type and we don't serve you. Go somewhere else."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "No, please.  There's nowhere else to go.  I know you must have something back there."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Sir, you need to leave."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "JUST GIVE ME SOME PANTS, FOR CHRIST SAKE! What is wrong with you people?!" Jarrod's face was turning red.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "You people?" the lady retorted.  She looked back and shouted "Hoa, come here!"
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Jarrod put his hands up, "No, ma'am, please, I don't want any trouble, I just need some pants and I will go.  I promise."
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          A stout man emerged from the back room.  His brow furrowed. Fast. He began to say something, but Jarrod knew he needed to get out of there. Of course they weren't going to help him.  Why did he think to rely on anyone here.  He bolted out the door and went sprinting down the road.  Gas station.  Bakery.  Pawn shop.  Luckily, not many people were out and about at this hour, but the few that were couldn't help but stare and start to sicker.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          He kept on going.  Barber. Coffee shop.  Yes!!  A thrift store.  He raced up to the door and pushed the handle. Locked. It soon became obvious that he wouldn't be able to find an open store, so he sneaked around behind the shop and found a small patch of grass hidden behind the dumpster at the apartment building across the alley.  He laid down and decided to try and close his eyes to take a nap until something else was open.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          But he couldn't stop his mind from racing.  Why did he decide to take that business trip?  Why did he let Cecilia convince him to take this deal?  It was beneath him, but he just couldn't say no.  The payout was too good and she was just too luscious.  The way she said it as she picked up his things before walking out the front door, "You've got a problem, Jarrod."  The bouncer didn't even stop her. And before he could get out from under the (heavily) perfumed worker, she was gone.  Peeling away in his BMW.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Hey!" The voice startled him and he jolted awake.  He must have fallen asleep after all and now found a tall man towering over him. "You can't sleep here!"
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Jarrod jumped up and started running around the building.  He tried the door handle again. SUCCESS!  This time he didn't even try to talk to anyone.  He just snatched the first shirt and pair of pants he could see and made a beeline for the door.  To his chagrin, nobody cared much about thrift store thievery.  Regardless, he didn't stop.  He ran as fast as he could.  He ran and ran until the wind sucked off the stink of last night.  And when he had finally run out of steam, he paused.  To catch his breath. To slip on the clothes he snatched. To regroup.  After a few minutes he started to walk again. He wasn't sure where he was going, or how he would find his way out of this trash town…but at least, for the time being, he was wearing pants again.
        </p>
      </>
    )
  },
  'a-nice-family': {
    id: 'a-nice-family',
    title: 'A nice family',
    content: (
      <>
        <p className="text-slate-800 leading-relaxed mb-4">
          Without much hesitation the boy climbed onto the seat of the train car, the wheels of his toy car spinning up the vinyl cushion.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Vroom," gushed from the boys mouth, then a crashing sound, "prshcaah."  I couldn't help but spit up my juice a bit as I tried to hold in my laugh.  I often get the giggles in these moments, when a memory comes rushing into my brain, crashing into my attention just like the pole broke through the windshield that night.  I've been told I have a weird gift of chuckling off life-shattering events, which is quite a quizzical way to look at things.  I think it's just nerves bubbling to the surface.  The boy's mother didn't seem to think it was funny.  And it wasn't, really.  It wasn't like I was laughing because it was funny.  She glared in my direction and whispered something to the boy, who looked up at me, sheepishly.  I assumed she hushed him upon noticing that I had been staring.  My brain is still a bit uncoupled at this stage, but I don't always realize it when I am acting strange in public.  Her piercing eyes burned into the stitches on my forehead.  I'm sure I look a bit Frankenstein, so I shrug it off and give her a haft-hearted smile.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          The boy continued his game, whistling the tone of a siren as his fire truck zoomed onto the scene, knocking another car to the ground.  The wheels rolled the car to my feet, and I bent down to pick it up.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Whoopsie," I muttered, handing the car back to the child.  "Looks like we're gonna need an ambulance," a big grin coming to my face as I stated it so matter-of-factly. The tone in my voice caused his mom to purse her lips.  Perhaps she thought that she knew what it was that could've bore ten stitches into my skull.  I guess on the train, you run into all sorts of unsultry types.  I was just yearning to see my nephew, play toy cars with him, and give him a big hug.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          My brother always said he wanted it to be a celebration.  A big party commemorating all the good times.  I didn't feel like partying, but I was going to do my best to honor that wish.  The train stopped and the mother ushered her son to another seat.  I just kept on smiling, rubbing the soreness in my neck and then taking a sip of my juice.  Orange juice, they said, was good for keeping my body strong in healing.  I leaned over to the old lady sitting to my right, "What a nice family."  She didn't acknowledge my comment, but that was well enough because I had to get off the train anyway.  I stumbled out of the carriage, still a bit wobbly on my feet.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          As I walked the 8 blocks to get to the memorial, I passed numerous bakeries and cafes.  There were the families getting their afternoon tea, picking up bread for dinner, or having a snack on the way home from school or work.  I approached the building feeling exhausted from my short gallop.  The sun was beating down and I could feel it searing into the open crevice on my face.  I opened the door and saw him sitting there, looking down at the ground. I gathered my breath and collected my emotions.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Hey buddy," I muttered.  "What you got there?"  I was looking at the collection of toys layed at his feet.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "It's a nice family…" he said.  "…and Daddy just takin' a lil' nap."  I reached my arm around his shoulders and gave him a squeeze.  He looked up at me and tried to muster a smile, but it was obvious he was jolted. We sat there and stared at the ground together, examining the dolls.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          "Yeah...it is, isn't it?"
        </p>
      </>
    )
  },
  'hey-there': {
    id: 'hey-there',
    title: 'Hey There',
    content: (
      <>
        <p className="text-slate-800 leading-relaxed mb-4">
          Hey there,
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          It's been a rough week.  When I feel like this, I never know where to start.  I guess I thought that the shit was over, but it just keeps bubbling up.  I don't think they realize how much pressure I am under.  These workdays keep getting longer, and sometimes it's like there's not even anything to do but the boss just makes me stay here.  It's probably because he's just distracted by his phone and doesn't realize that I'm done with all the business.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Maybe I am just being an ass, but I'm kind of sore about it.  People might say I'm obsessing over this because any time I spend away from doing business, I just hang out alone in the dark.  I never really leave my place, so yeah, I guess I am a recluse.  Sometimes my boss will invite someone over, and then I'll have them come inside, but that's not as frequent as you might like to think.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          After a long week, all I want is to just wash up and tuck in, but I think I have to go out again tonight to "rub shoulders" as they say.  Something the boss is asking me to do again.  Yeah, I know, I should really stand up to him, but it really feels like I have no legs.  And anytime I try to protest, what I spew out isn't pretty–then the boss just gets mad at me for ruining his day.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          To be honest, I'm a bit fed up with this crap. I can't really take it anymore. If I said I didn't give a shit, well–I can't really say that, cause I do.  However, instead of getting all gassed up about it, maybe I should just make a run for it.  They say that regular runs can make you feel better.  The boss won't like it, me making him late to work (or even miss work) on account of it, but tough shit!  He's been squeezing everything he can out of me and it's not fair.  Don't worry, I'm not gonna take the piss–I'm not a dick.  I won't give him the shaft either.  I'll just push when it makes sense and hopefully something good will come out of it.  That's really the best I can do.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          I'm glad I could get this out–I was feeling really backed up, like there was a heavy weight inside of me I just couldn't get out.  It's nice to know I can let it all out here.   It's such a blessing to have you here to help me clean up my mess and pull myself together again.  Most people don't really appreciate you, but I definitely do.  I don't think you're an asswipe at all.  I find you very soft and comforting.  Thank you for always taking all my shit and not throwing it back in my face like they do at work.  I know this is a lot to clear up.  I will try my best to work things through with the boss and handle my business.  I just hope you can keep it together when it all gets flushed out.  I think if it all works as I'm hoping, you're gonna end up with a wad, but I wouldn't worry about it..  Honestly, you're on a roll.
        </p>
        <p className="text-slate-800 leading-relaxed mb-4">
          Sincerely,<br />
          Butthole
        </p>
      </>
    )
  },
  'stupid-boys': {
    id: 'stupid-boys',
    title: 'Stupid boys',
    content: (
      <>
        <div className="text-slate-800 leading-relaxed text-base md:text-lg space-y-3 mb-4">
          <p className="text-slate-800 leading-relaxed">
            They waltzed out to the pasture
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            Tiny dynamite sticks in hand
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            And a steel pipe
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            Playing with fire
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            Sparked to ignite
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            Down the tube
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            No more middle finger
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            No more Independence day
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed font-semibold mt-4">
            Stupid boys
          </p>
        </div>
      </>
    )
  },
  'my-cult-is-an-awesome-cult': {
    id: 'my-cult-is-an-awesome-cult',
    title: 'My Cult is an Awesome Cult',
    content: (
      <>
        <div className="text-slate-800 leading-relaxed text-base md:text-lg space-y-4 mb-4">
          <p className="text-slate-800 leading-relaxed">
            My cult is an awesome cult
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            They let me wear skirts
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            And I get a nice sash
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            There's a nice man with a moustache
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            He gives me rides sometimes
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            When we are together, it is just divine
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            There's no other place I would rather be
          </p>
          
          <p className="text-[var(--brutal-muted)] leading-relaxed mt-6">
            My cult is an awesome cult
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            They tell me I am special
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            And because I am special I will be here for a while
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            But I like the darkness
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            It's calming
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            Sometimes they come to me and they tell me things
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            They are nice to speak loud so that I can hear them
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            They are also really great at being honest
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            I don't like it when people just tell me the nice things about myself
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            It's dishonest.
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            Who wants to just hear nice things?  How will they ever improve?
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            How will they ever reach their full potential?
          </p>
          
          <p className="text-[var(--brutal-muted)] leading-relaxed mt-6">
            My cult is an awesome cult
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            They give opportunities
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            When I am grown, I will leave this dark room
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            And I will get a real nice ride from mr. moustache
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            We will go to another special place together
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            My child will be the chosen one.
          </p>
          
          <p className="text-[var(--brutal-muted)] leading-relaxed mt-6">
            My cult is an awesome cult
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            They know heaven
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            And they know how to get there
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            We just drink the kool aid
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            It was the one chosen for us.
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            I will miss my baby
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            But he will still be inside me when I reach the pearly gates
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            I'll get to wear my skirt
          </p>
          <p className="text-[var(--brutal-muted)] leading-relaxed">
            And my sash, too.
          </p>
          
          <p className="text-[var(--brutal-muted)] leading-relaxed mt-6 font-semibold">
            My cult is an awesome cult
          </p>
        </div>
      </>
    )
  }
}

export default function Story() {
  const { storyId } = useParams<{ storyId: string }>()
  const story = storyId ? storyContent[storyId] : null

  if (!story) {
    return (
      <Components.PageContainer>
        <Components.SkipLink />
        <Components.GlassNavigation />
        
        <main id="main-content" tabIndex={-1} className="pt-16 md:pt-32 pb-16 px-4 md:px-6" role="main">
          <div className="max-w-4xl mx-auto">
            <Card className="brutal-panel p-12 text-center">
              <h1 className="text-2xl font-bold text-[var(--brutal-ink)] mb-4">Story Not Found</h1>
              <p className="text-[var(--brutal-muted)] mb-6">The story you're looking for doesn't exist.</p>
              <Button asChild variant="outline" className="border-[var(--brutal-ink)] text-[var(--brutal-ink)] hover:bg-[var(--brutal-panel)]">
                <Link to="/Writing">
                  <ArrowLeft weight="duotone" className="w-4 h-4 mr-2" />
                  Back to Writing
                </Link>
              </Button>
            </Card>
          </div>
        </main>
      </Components.PageContainer>
    )
  }

  return (
    <Components.PageContainer className="min-h-screen min-h-[100dvh]">
      <Components.SkipLink />
      <Components.GlassNavigation />
      
      <main id="main-content" tabIndex={-1} className="pt-16 md:pt-32 pb-16 px-4 md:px-6 bg-[#faf5ed] min-h-screen min-h-[100dvh]" role="main" aria-label={`Story: ${story.title}`} style={{ backgroundColor: '#faf5ed', minHeight: '100dvh' }}>
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <header className="mb-8 md:mb-12">
            <Button
              asChild
              variant="ghost"
              className="mb-6 text-slate-800 hover:bg-stone-200/50 border-stone-300"
            >
              <Link to="/Writing">
                <ArrowLeft weight="duotone" className="w-4 h-4 mr-2" />
                Back to Writing
              </Link>
            </Button>
          </header>

          {/* Story Content */}
          <Card className="bg-white/60 backdrop-blur-sm border border-stone-300/50 p-6 md:p-8 shadow-xl">
            <article className="prose max-w-none">
              <header className="mb-6 md:mb-8">
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-800 leading-tight break-words mb-2">
                  {story.title}
                </h1>
                {story.date && (
                  <p className="text-base md:text-lg text-slate-600">{story.date}</p>
                )}
              </header>
              <div className="text-slate-800 leading-relaxed text-base md:text-lg space-y-4 break-words">
                {typeof story.content === 'string' ? (
                  <div className="whitespace-pre-wrap">{story.content}</div>
                ) : (
                  story.content
                )}
              </div>
            </article>
          </Card>
        </div>
      </main>
    </Components.PageContainer>
  )
}
